export function isSite(node) {
  return node && (node.tag === 'site' || node.tag === 'asset');
}

export function isAreaNode(node) {
  return node.parentId && !this.isSite(node);
}

// 返回每个节点的场站数，去掉无模型的场站，如果有modelIds参数，则按照这个模型过滤
export function countSiteOneNode(tree, domainIds) {
  const sitesCount = countSite(tree, domainIds);
  return sitesCount[tree.id];
}

// 返回每个节点的场站数，去掉无模型的场站，如果有modelIds参数，则按照这个模型过滤
export function countSite(tree, mdmTypes) {
  const sitesCount = {};
  function countNode(node) {
    if (isSite(node)) {
      if (mdmTypes) {
        sitesCount[node.id] = mdmTypes.includes(node.mdmType) ? 1 : 0;
      } else {
        sitesCount[node.id] = node.mdmType ? 1 : 0;
      }
    } else {
      sitesCount[node.id] = node.children.map(countNode).reduce((l, n) => l + n, 0);
    }
    return sitesCount[node.id];
  }
  countNode(tree);
  return sitesCount;
}

// 把树平铺，并做浅拷贝，后续修改节点不会修改原始树节点
export function tree2array(tree) {
  if (Array.isArray(tree)) {
    return tree.map(tree2array).flat();
  }
  return [{...tree}, ...(tree.children || []).map(tree2array).flat()];
}

// 把树平铺，返回的是原始节点
export function tree2arrayCopy(tree) {
  if (Array.isArray(tree)) {
    return tree.map(tree2array).flat();
  }
  return [tree, ...(tree.children || []).map(tree2array).flat()];
}

export function array2tree(array) {
  array.forEach((node) => {
    node.children = array.filter(c => c.parentId === node.id);
  });
  array.forEach((node) => {
    if (!node.children.length) {
      delete node.children;
    }
  });
  return array.find(node => !node.parentId);
}

export function getSiteListByNode(node, domainIds) {
  if (!node) { return []; }
  if (isSite(node)) {
    if (domainIds) {
      return (domainIds.includes(node.domain) || domainIds.includes('ALL')) ? [node] : [];
    }
    return node.domain ? [node] : [];
  }
  return node.children ? [].concat(...node.children.map(c => getSiteListByNode(c, domainIds))) : [];
}
